interface IAssertOptions {
  alert: boolean,
}

export function assert(condition: boolean, message = 'Assertion Error', options: Partial<IAssertOptions> = {}) {
  const { alert } = options
  if (!condition) {
    console.error(message)
    alert && window.alert(message)
    debugger
    throw new Error(message)
  }
}
